// extracted by mini-css-extract-plugin
export default {"wrap":"TextSlider_wrap__K+cFt","movingText":"TextSlider_movingText__pN0JW","marquee":"TextSlider_marquee__5PlGb"};